<template>
  <header class="header-bar">
    <div class="power">技术支持：医圆科技</div>
    <div class="title">全国医学影像质控智能监测平台</div>
    <div class="timer">
      {{ timer }}
    </div>
  </header>
</template>
<script setup>
import dayjs from "dayjs";
import { ref } from "vue";
// 这里可以引入 props 或后续逻辑
const timer = ref(dayjs().format("YYYY-MM-DD HH:mm:ss"));
setInterval(() => {
  timer.value = dayjs().format("YYYY-MM-DD HH:mm:ss");
}, 1000);
</script>
<style scoped lang="less">
@import "@/assets/css/global.less";
.header-bar {
  height: 60px;
  background: @primary-color;
  display: flex;
  align-items: center;
  padding: 0 32px;
  color: @text-color;
  font-size: 18px;
  justify-content: space-between;
}
.power {
  font-size: 14px;
  color: @text-color-secondary;
}
.title {
  flex: 1;
  text-align: center;
  font-size: 20px;
}
.timer {
  margin-left: 16px;
  font-size: 16px;
  color: @text-color-secondary;
}
</style>
